import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { MsalService } from '@azure/msal-angular';
import { Router } from '@angular/router';

@Injectable()
export class AuthenticationErrorInterceptor implements HttpInterceptor {
  private isLoggingOut = false;

  constructor(private msalService: MsalService,
    private router: Router) { }


  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {

        // Only handle auth-related errors
        if (error.status === 403 && !this.isLoggingOut) {
          this.isLoggingOut = true;

          // Clear app/session state
          localStorage.clear();
          sessionStorage.clear();

          // OPTIONAL: if backend sends explicit inactive-user code
          const isInactiveUser =
            error.error?.errorCode === 'USER_INACTIVE' ||
            error.error?.message?.toLowerCase().includes('inactive');

          // Always force logout for auth failures          
          this.msalService.logoutRedirect();
        }

        return throwError(() => error);
      })
    );
  }
}
